import React, { useState } from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';

const CommentSection = () => {
  const [comments, setComments] = useState([]);
  const [commentText, setCommentText] = useState("");
  const [commentMessage, setCommentMessage] = useState('');
  const navigate = useNavigate();


  const handleCommentSubmit = (event) => {
    event.preventDefault();
    if (commentText.trim() !== '') {
      setComments([...comments, commentText]);
      setCommentText("");
      setCommentMessage('Comment submitted successfully!');
      setTimeout(() => setCommentMessage(''), 3000);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Box
      sx={{
        maxWidth: '800px',
        // mx: 'auto',
        // p: { xs: 2, md: 4 }, 
        mx: { xs: '1rem', sm: '4rem', md: '6rem', lg: '7rem' },
        p: { xs: 2, md: 2 },
        mt: 4
      }}
    >
      <Typography variant="h5">
        Leave a Comment
      </Typography>
      <form onSubmit={handleCommentSubmit} noValidate>
        <TextField
          fullWidth
          variant="outlined"
          label="Your Comment"
          value={commentText}
          onChange={(e) => setCommentText(e.target.value)}
          multiline
          rows={4}
          sx={{ mb: 2, borderRadius: '10rem' }}
        />
        <Button type="submit" variant="contained" sx={{ mt: 2, borderRadius: '1.2rem' }}>
          Submit
        </Button>
        {commentMessage && (
          <Typography sx={{ mt: 2, backgroundColor: '#cfcfcf', borderRadius: '1.2rem', p: 1, textAlign: 'center' }}>
            {commentMessage}
          </Typography>
        )}
      </form>

      <Typography variant="h6" sx={{ mt: 4 }}>
        Comments ({comments.length})
      </Typography>

      {/* Comments List */}
      <Box sx={{ maxHeight: 300, overflow: 'auto', mt: 2 }}>
        {comments.map((comment, index) => (
          <Typography key={index} sx={{ mt: 1 }}>
            {comment}
          </Typography>
        ))}
        {comments.length === 0 && (
          <Typography>No comments yet.</Typography>
        )}
      </Box>

      <Button variant="contained" color="primary" onClick={handleBack} startIcon={<ArrowBack />}
        sx={{
          display: 'flex',
          placeContent: 'center',
          margin: 'auto',
          mt: 5,
          borderRadius: 10,
          transition: 'background-color 0.3s ease',
          ':hover': {
            backgroundColor: '#f39c12',
            color: 'white',
          },
        }}>
        Back
      </Button>
    </Box>
  );
};

export default CommentSection;
